import { render, staticRenderFns } from "./ProvenanceGraph.vue?vue&type=template&id=a21d6bf4&scoped=true&"
import script from "./ProvenanceGraph.vue?vue&type=script&lang=js&"
export * from "./ProvenanceGraph.vue?vue&type=script&lang=js&"
import style0 from "./ProvenanceGraph.vue?vue&type=style&index=0&id=a21d6bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21d6bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21d6bf4')) {
      api.createRecord('a21d6bf4', component.options)
    } else {
      api.reload('a21d6bf4', component.options)
    }
    module.hot.accept("./ProvenanceGraph.vue?vue&type=template&id=a21d6bf4&scoped=true&", function () {
      api.rerender('a21d6bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/bottomLineProvenance/ProvenanceGraph.vue"
export default component.exports